'use client';
import { createContext, useContext } from 'react';
export const FieldContext = createContext(null);
export function useFieldContext() {
    return useContext(FieldContext);
}
/** A description or error node that renders nothing counts as absent. */
export function hasMessageContent(node) {
    return node != null && node !== false && node !== '';
}
//# sourceMappingURL=FieldContext.js.map